import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d108d5c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "page" };
const _hoisted_2 = { class: "card" };
const _hoisted_3 = { class: "" };
const _hoisted_4 = { class: "field" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "sourceService" }, [
    /*#__PURE__*/ _createTextVNode("交換元サービス"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "未選択", -1));
const _hoisted_7 = ["value"];
const _hoisted_8 = { class: "field" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "targetService" }, [
    /*#__PURE__*/ _createTextVNode("交換先サービス"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "未選択", -1));
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "field" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "exchangeRate" }, [
    /*#__PURE__*/ _createTextVNode("交換倍率"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_14 = { class: "input-with-prefix" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "prefix" }, "×", -1));
const _hoisted_16 = { class: "field" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "effective_period_date" }, [
    /*#__PURE__*/ _createTextVNode("有効日数"),
    /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "必須")
], -1));
const _hoisted_18 = { style: { "display": "flex" } };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { style: { "font-size": "20px" } }, "日", -1));
const _hoisted_20 = { class: "button-row" };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    class: "btn-setting",
    type: "submit"
}, "登録", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TwoLineTitle = _resolveComponent("TwoLineTitle");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_TwoLineTitle, {
                    msgLine1: 'ポイント交換',
                    msgLine2: '倍率登録',
                    submsgLine1: 'Points Conversion',
                    submsgLine2: 'Rate Register'
                })
            ]),
            _createElementVNode("div", null, [
                _createElementVNode("form", {
                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
                    //@ts-ignore
                    (...args) => ($options.onSubmit && $options.onSubmit(...args)), ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _withDirectives(_createElementVNode("select", {
                            id: "sourceService",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($data.form.sourceService) = $event))
                        }, [
                            _hoisted_6,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.serviceInfo, (service) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: service.pointTypeId,
                                    value: service.service
                                }, _toDisplayString(service.service), 9, _hoisted_7));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, $data.form.sourceService]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _withDirectives(_createElementVNode("select", {
                            id: "targetService",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.form.targetService) = $event))
                        }, [
                            _hoisted_10,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.serviceInfo, (service) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: service.service,
                                    value: service.service
                                }, _toDisplayString(service.service), 9, _hoisted_11));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, $data.form.targetService]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _withDirectives(_createElementVNode("input", {
                                id: "exchangeRate",
                                type: "text",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($data.form.exchangeMagnification) = $event))
                            }, null, 512), [
                                [_vModelText, $data.form.exchangeMagnification]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "effective_period_date",
                                name: "effective_period_date",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($data.form.effectivePeriodDate) = $event))
                            }, null, 512), [
                                [_vModelText, $data.form.effectivePeriodDate]
                            ]),
                            _hoisted_19
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                            class: "btn-back",
                            type: "button",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => ($options.onCancel && $options.onCancel(...args)))
                        }, " 戻る "),
                        _hoisted_21
                    ])
                ], 32)
            ])
        ])
    ]));
}
